/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserDetails } from './types';
import { apiClient } from '@/utils/apiClient';

export const fetchUserDetails = createAsyncThunk<
  UserDetails,
  void,
  { rejectValue: string }
>('userProfile/fetchUserDetails', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient('/auth/api/v1/user/', { method: 'GET' });
    return response as UserDetails;
  } catch (err: any) {
    return rejectWithValue(err.message || 'Failed to load user details');
  }
});
